export default __webpack_public_path__ + "static/media/international.32524849.svg";